import type { VoiceCallStatus } from '@/lib/twilio-voice';

export type DialerLivePollingProfile = {
  sessionLookupMs: number;
  messagesMs: number;
  eventsMs: number;
  callsMs: number;
  feedbackMs: number;
  suggestionsMs: number;
};

const IDLE_PROFILE: DialerLivePollingProfile = {
  sessionLookupMs: 5_000,
  messagesMs: 5_000,
  eventsMs: 3_000,
  callsMs: 8_000,
  feedbackMs: 8_000,
  suggestionsMs: 12_000,
};

const PRE_CONNECT_PROFILE: DialerLivePollingProfile = {
  sessionLookupMs: 2_500,
  messagesMs: 2_500,
  eventsMs: 1_250,
  callsMs: 3_000,
  feedbackMs: 6_000,
  suggestionsMs: 12_000,
};

const IN_CALL_PROFILE: DialerLivePollingProfile = {
  sessionLookupMs: 2_000,
  messagesMs: 2_000,
  eventsMs: 900,
  callsMs: 2_000,
  feedbackMs: 5_000,
  suggestionsMs: 10_000,
};

export function resolveDialerLivePollingProfile(input: {
  callStatus: VoiceCallStatus;
  hasActiveCall: boolean;
}): DialerLivePollingProfile {
  if (input.callStatus === 'in-progress' && input.hasActiveCall) {
    return IN_CALL_PROFILE;
  }

  if (input.callStatus === 'calling' || input.callStatus === 'ringing') {
    return PRE_CONNECT_PROFILE;
  }

  return IDLE_PROFILE;
}
